import styled from 'styled-components';
import { Text, FlexRow } from '@make-software/tg-mini-app-ui';

import { IBadgeProps } from './index';

export const BadgeContainer = styled(FlexRow)<Pick<IBadgeProps, 'badgeColor'>>(
  ({ theme, badgeColor }) =>
    theme.withMedia({
      padding: '0 4px',
      borderRadius: 4,
      backgroundColor: badgeColor
    })
);

export const BadgeText = styled(Text)<Pick<IBadgeProps, 'textColor'>>(({ theme, textColor }) =>
  theme.withMedia({
    color: textColor,
    fontSize: '11px',
    fontWeight: 400,
    letterSpacing: '-0.22px',
    lineHeight: '140%',
    textAlign: 'center',
    fontFamily: 'Inter'
  })
);
